

























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import appconst from '@/lib/appconst';
import Enums from '@/lib/enums'

class AddModel {
    thirdPartySku: string;
    productSku: string;
    stockProductInfoId: number;
}
@Component
export default class CreatemodelModule extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    model: AddModel = new AddModel();
    selectDate: string = "";
    selectDates: string = "";
    addLoding = false;
    siteType = Enums.SiteSType;
    whetherLocalList = Enums.WhetherLocal;
    amountTotal: string = '';;
    isShow: boolean;
    created() {
    }
    signFor() {
        this.save();
    }
    save() {
        (this.$refs.skuForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.addLoding = true;
                this.model.stockProductInfoId = this.$store.state.frontstockproduct.id;
                await this.$store.dispatch({
                    type: 'skumapping/Add',
                    data: this.model
                }).finally(() => {
                    this.addLoding = false;
                });

                (this.$refs.skuForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input', false);

            }
        })
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
            this.$set(this.model, "productSku", this.$store.state.frontstockproduct.sku);
        }
    }
    cancel() {
        (this.$refs.skuForm as any).resetFields();
        this.$emit('input', false);
    }

    modelRule = {
        thirdPartySku: [
            { required: true, message: '第三方平台Sku不能为空', trigger: 'blur' }
        ],
        productSku: [
            { required: true, message: '商家产品Sku不能为空', trigger: 'blur' }
        ],
    };

}
